import script from "./typeList.vue?vue&type=script&setup=true&lang=js"
export * from "./typeList.vue?vue&type=script&setup=true&lang=js"

import "./typeList.vue?vue&type=style&index=0&id=01ae480d&lang=scss"

const __exports__ = script;

export default __exports__